module.exports = __webpack_public_path__ + "assets/img/Rakuten.c5726597.png";